import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import { Building2, MapPin, ExternalLink } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Auctioneers() {
  const [list, setList] = useState([]);
  const [states, setStates] = useState([]);
  const [uf, setUf] = useState("all");

  useEffect(() => {
    api.get("/meta/states").then((r) => setStates(r.data.states));
  }, []);
  useEffect(() => {
    api.get(uf === "all" ? "/auctioneers" : `/auctioneers?uf=${uf}`).then((r) => setList(r.data.auctioneers));
  }, [uf]);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-emerald-400">Diretório</div>
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-1">Leiloeiros Judiciais Oficiais</h1>
            <p className="text-slate-400 text-sm mt-1">Registrados nas juntas comerciais dos estados brasileiros.</p>
          </div>
          <Select value={uf} onValueChange={setUf}>
            <SelectTrigger className="w-56 bg-slate-900 border-slate-800 h-11" data-testid="auctioneers-uf-filter"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-slate-900 border-slate-800 max-h-72">
              <SelectItem value="all">Todos os estados</SelectItem>
              {states.map((s) => <SelectItem key={s.uf} value={s.uf}>{s.uf} — {s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((a) => (
            <div key={a.id} className="p-5 rounded-xl bg-slate-900/70 border border-slate-800 card-hover" data-testid={`auctioneer-card-${a.id}`}>
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
                  <Building2 className="w-5 h-5 text-emerald-400" />
                </div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" />{a.uf}</div>
              </div>
              <h3 className="mt-3 font-semibold text-white">{a.name}</h3>
              <div className="text-xs text-slate-400 mt-1">{a.matricula} · {a.junta}</div>
              <div className="mt-3 flex items-center justify-between text-sm">
                <span className="text-slate-400">Lotes ativos: <span className="font-mono text-emerald-400 font-bold">{a.active_lots}</span></span>
                <a href={a.website} target="_blank" rel="noreferrer" className="text-emerald-400 hover:text-emerald-300 text-xs inline-flex items-center gap-1">
                  Site <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
